import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  Button,
  CardFooter,
  CardHeader,
} from '@nextui-org/react';
import { URLs } from '../../../constants/apiEndpoints';
import { PrivateAxiosInstance } from '../../../services/createAxiosInstance';
import EditSignalModal from '../../../components/Modal/EditSignalModal';
import moment from 'moment';
import {
  useInfiniteQuery,
  useQuery,
  useQueryClient,
  useMutation,
} from '@tanstack/react-query';
import { getAllSignal, deleteSignal } from '../../../services/signalQuery';
import { message } from 'antd';
import { decryptData } from '../../../utils/encryptData';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { MdOutlineAttachMoney } from 'react-icons/md';
import { FaArrowTrendDown, FaArrowTrendUp } from 'react-icons/fa6';
import { AiOutlineStop } from 'react-icons/ai';
import { GrAchievement } from 'react-icons/gr';
import { PiWarningFill } from 'react-icons/pi';
import { BsThreeDotsVertical } from 'react-icons/bs';
import PostDropdown from '../../../components/PostDropdown/PostDropdown';
import Loading from '../../../components/Loading/Loading';
import Rating from '../../../components/Rating/Rating';

function TradingSignal() {
  const { uid, rl } = useSelector((state) => state.auth);
  const loggedInUserId = decryptData(uid);
  const role = decryptData(rl);

  const queryClient = useQueryClient();

  const {
    isLoading,
    data = [],
    error,
  } = useQuery({
    queryKey: ['signal'],
    queryFn: () => getAllSignal(12),
    refetchOnWindowFocus: false,
  });

  //delete post
  const { mutate: deleteSignalMutation, isLoading: isDeleteSignalLoading } =
    useMutation({
      mutationFn: deleteSignal,
      onError: (error) => {
        console.error('Error Delete signal:', error);
        message.error(error?.response?.data?.error || error.message);
      },
      onSuccess: async () => {
        message.success('Signal Delete successfully');
        await queryClient.invalidateQueries(['signal']);
      },
    });

  //delete post
  const handelDeletePost = async (id) => {
    if (!id) {
      message.error('Signal id not found!');
      return;
    }
    deleteSignalMutation(id);
  };

  return (
    <>
      <h5 className="mb-3 text-xl md:text-3xl font-bold tracking-tight font-poppins text-gray-300 mt-[20px] md:mt-[85px]">
        Trading Signal
      </h5>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        {isLoading ? (
          <Loading isLoading={isLoading} />
        ) : error ? (
          <p className="p-3 text-white">Error loading signals</p>
        ) : data?.length === 0 ? (
          <p className="p-3 text-white">No data available</p>
        ) : (
          data?.map((signal) => (
            <Card
              key={signal?.signalId}
              className="bg-background-secondary-color mt-5 w-full"
            >
              <CardBody>
                <CardHeader className="flex flex-inline justify-center items-center">
                  <Rating number={3} />
                </CardHeader>
                <Button
                  startContent={
                    <MdOutlineAttachMoney
                      className="text-btn-color"
                      size={25}
                    />
                  }
                  className="text-lg font-semibold text-poppins text-gray-200 bg-transparent"
                  variant="flat"
                >
                  {signal?.currentPair}
                </Button>

                <h4 className="text-md font-semibold text-poppins text-gray-200 inline-flex items-center">
                  {signal.orderType === 'buyLimit' ? (
                    <FaArrowTrendUp
                      className="text-green-500 mr-2 opacity-80"
                      size={22}
                    />
                  ) : (
                    <FaArrowTrendDown
                      className="text-red-500 mr-2 opacity-80"
                      size={22}
                    />
                  )}
                  {signal?.orderType === 'buyLimit'
                    ? 'BUY LIMIT '
                    : 'SELL LIMIT '}{' '}
                  - {signal.value}
                </h4>

                <h4 className="text-md font-normal text-poppins text-gray-300 inline-flex items-center mt-2 mb-2">
                  <GrAchievement
                    className="text-green-500 mr-2 opacity-80"
                    size={18}
                  />
                  TP1 - {signal?.targetLevel1}
                </h4>

                <h4 className="text-md font-normal text-poppins text-gray-300 inline-flex items-center mb-2">
                  <GrAchievement
                    className="text-green-500 mr-2 opacity-80"
                    size={18}
                  />
                  TP2 - {signal?.targetLevel2}
                </h4>

                <h4 className="text-md font-normal text-poppins text-gray-300 inline-flex items-center mb-2">
                  <GrAchievement
                    className="text-green-500 mr-2 opacity-80"
                    size={18}
                  />
                  TP3 - {signal?.targetLevel3}
                </h4>

                <h4 className="inline-flex items-center text-md font-normal text-poppins text-gray-300 line-clamp-2 mb-2">
                  <AiOutlineStop
                    className="text-red-500 mr-2 opacity-80"
                    size={18}
                  />
                  SL - {signal?.stopLoss}
                </h4>
                <p className="text-sm font-normal text-poppins text-gray-400">
                  {moment(signal?.updatedAt).format('YYYY/MM/DD - h:m a')}
                </p>
              </CardBody>
              <CardFooter className="flex justify-between item-center">
                {role === 'admin' && (
                  <>
                    <PostDropdown
                      deleteItem={() => handelDeletePost(signal?.signalId)}
                    />

                    <EditSignalModal id={signal?.signalId} />
                  </>
                )}
              </CardFooter>
            </Card>
          ))
        )}
      </div>
    </>
  );
}

export default TradingSignal;
